/*
 * Kurs-Zustimmung - Glanzstueck Berlin
 * Ersetzt die App "Checkbox Assistant V2".
 *
 * Setzt die Pflicht-Checkboxen oberhalb jedes Kasse-Buttons ein (Warenkorb-Drawer
 * und /cart), sperrt Kasse sowie Express-Checkout bis alles angehakt ist und legt
 * die Zustimmung als Bestellattribut "Kurs-Zustimmung" an der Bestellung ab.
 *
 * Sicherheitsprinzip: Gesperrt wird ausschliesslich, wenn im Warenkorb tatsaechlich
 * ein Kursprodukt liegt. Schlaegt die Warenkorbabfrage fehl, bleibt alles offen -
 * ein kaputter Checkout waere schlimmer als eine fehlende Checkbox.
 */
(function () {
  if (window.__kursZustimmungInit) return;
  window.__kursZustimmungInit = true;

  var ATTR_NAME = 'Kurs-Zustimmung';
  var STORAGE_KEY = 'kz-state';
  var CHECKOUT_SELECTOR = 'button[name="checkout"], #checkout-submit';
  var EXPRESS_SELECTOR =
    '.dynamic-checkout__content, [data-shopify="dynamic-checkout-cart"], [data-shopify="payment-button"], .shopify-payment-button';

  var cartProductIds = null;
  var lastFetch = 0;
  var fetching = false;
  var saveTimer = null;
  var lastSaved = null;
  var pending = null;

  function readState() {
    try {
      return JSON.parse(sessionStorage.getItem(STORAGE_KEY) || '{}');
    } catch (e) {
      return {};
    }
  }

  function writeState(state) {
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(state));
    } catch (e) {}
  }

  function refreshCart() {
    var now = Date.now();
    if (fetching || now - lastFetch < 800) return;
    fetching = true;
    lastFetch = now;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        cartProductIds = (cart.items || []).map(function (i) { return String(i.product_id); });
        fetching = false;
        sync();
      })
      .catch(function () { fetching = false; });
  }

  function courseIdsInCart(tpl) {
    if (!cartProductIds) return null;
    var courses = (tpl.getAttribute('data-kz-courses') || '').split(',');
    return courses
      .map(function (id) { return id.trim(); })
      .filter(function (id) { return id && cartProductIds.indexOf(id) !== -1; });
  }

  function removeBlocks() {
    document.querySelectorAll('[data-kz-wrap]').forEach(function (n) { n.remove(); });
    document.querySelectorAll('[data-kz-has-block]').forEach(function (b) {
      delete b.dataset.kzHasBlock;
    });
  }

  function insertBlocks(tpl) {
    var btns = document.querySelectorAll(CHECKOUT_SELECTOR);

    /* Aufraeumen, falls das Theme oder eine App die Buttons neu umbaut hat und
       dadurch mehr Bloecke stehen als Buttons vorhanden sind. */
    if (document.querySelectorAll('[data-kz-wrap]').length > btns.length) removeBlocks();

    btns.forEach(function (btn) {
      if (btn.dataset.kzHasBlock === '1') return;

      var host = btn.parentElement;
      if (!host) return;
      var anchor = btn;

      var style = window.getComputedStyle(host);
      if (style.display === 'flex' && style.flexDirection !== 'column' && host.parentElement) {
        anchor = host;
        host = host.parentElement;
      }

      var prev = anchor.previousElementSibling;
      if (prev && prev.hasAttribute && prev.hasAttribute('data-kz-wrap')) {
        btn.dataset.kzHasBlock = '1';
        return;
      }

      var frag = tpl.content.cloneNode(true);
      var wrap = frag.querySelector('[data-kz-wrap]');
      var formId = btn.getAttribute('form');
      if (formId) {
        wrap.querySelectorAll('[data-kz-attr]').forEach(function (input) {
          input.setAttribute('form', formId);
        });
      }
      host.insertBefore(frag, anchor);
      btn.dataset.kzHasBlock = '1';
    });
  }

  function lock(locked) {
    document.querySelectorAll(CHECKOUT_SELECTOR).forEach(function (btn) {
      if (locked) {
        btn.dataset.kzLocked = '1';
        btn.disabled = true;
        btn.classList.add('kz-disabled');
      } else if (btn.dataset.kzLocked === '1') {
        delete btn.dataset.kzLocked;
        btn.disabled = false;
        btn.classList.remove('kz-disabled');
      }
    });

    document.querySelectorAll(EXPRESS_SELECTOR).forEach(function (el) {
      if (locked) {
        el.dataset.kzLocked = '1';
        el.classList.add('kz-locked');
      } else if (el.dataset.kzLocked === '1') {
        delete el.dataset.kzLocked;
        el.classList.remove('kz-locked');
      }
    });
  }

  function timestamp() {
    try {
      return new Intl.DateTimeFormat('de-DE', {
        dateStyle: 'short',
        timeStyle: 'medium',
        timeZone: 'Europe/Berlin'
      }).format(new Date());
    } catch (e) {
      return new Date().toISOString();
    }
  }

  function labelOf(box) {
    var row = box.closest('[data-kz-row]');
    var span = row ? row.querySelector('.kz-text') : null;
    return span ? span.textContent.replace(/\s+/g, ' ').replace(/\s*\*\s*$/, '').trim() : '';
  }

  function buildValue(activeBoxes) {
    var stamp = timestamp();
    var seen = {};
    var parts = [];
    activeBoxes.forEach(function (box) {
      var key = box.getAttribute('data-kz-key');
      if (seen[key]) return;
      seen[key] = true;
      parts.push(parts.length + 1 + ': ' + stamp + ' (Europe/Berlin) - ' + labelOf(box));
    });
    return parts.join(' | ');
  }

  function persist(value) {
    if (value === lastSaved) return;
    lastSaved = value;
    clearTimeout(saveTimer);
    saveTimer = setTimeout(function () {
      var attributes = {};
      attributes[ATTR_NAME] = value;
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: attributes })
      }).catch(function () {});
    }, 500);
  }

  function sync() {
    var tpl = document.querySelector('template[data-kz-template]');
    if (!tpl) return;

    if (cartProductIds === null) {
      refreshCart();
      return;
    }

    var active = courseIdsInCart(tpl);

    if (!active || !active.length) {
      removeBlocks();
      lock(false);
      return;
    }

    insertBlocks(tpl);

    document.querySelectorAll('[data-kz-row]').forEach(function (row) {
      var need = (row.getAttribute('data-kz-product') || '').trim();
      row.hidden = need !== '' && active.indexOf(need) === -1;
    });

    var boxes = Array.prototype.slice
      .call(document.querySelectorAll('[data-kz-box]'))
      .filter(function (box) {
        var row = box.closest('[data-kz-row]');
        return row && !row.hidden;
      });

    if (!boxes.length) {
      lock(false);
      return;
    }

    var state = readState();
    boxes.forEach(function (box) {
      var want = !!state[box.getAttribute('data-kz-key')];
      if (box.checked !== want) box.checked = want;
    });

    var allOk = boxes.every(function (box) { return box.checked; });

    lock(!allOk);

    document.querySelectorAll('[data-kz-hint]').forEach(function (hint) {
      hint.hidden = allOk;
    });

    var value = allOk ? buildValue(boxes) : '';
    document.querySelectorAll('[data-kz-attr]').forEach(function (input) {
      input.value = value;
    });
    persist(value);
  }

  document.addEventListener('change', function (e) {
    var box = e.target;
    if (!box || !box.matches || !box.matches('[data-kz-box]')) return;
    var state = readState();
    state[box.getAttribute('data-kz-key')] = box.checked;
    writeState(state);
    sync();
  });

  var observer = new MutationObserver(function () {
    clearTimeout(pending);
    pending = setTimeout(function () {
      refreshCart();
      sync();
    }, 120);
  });

  function start() {
    refreshCart();
    sync();
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
